"use client";

import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const services = ["Artisan Sourdough", "Hand-Rolled Croissants", "Seasonal Fruit Tarts", "Custom Celebration Cakes", "Morning Pastry Boxes", "Wholesale Partnerships", "Baking Workshops"];
const quickLinks = [{
  label: "Home",
  href: "/HomePage"
}, {
  label: "Our Story",
  href: "/OurStoryPage"
}, {
  label: "Baker's Journal",
  href: "/BakersJournalPage"
}, {
  label: "Shop",
  href: "/ShopPage"
}];
const socialLinks = [{
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Twitter,
  href: "#",
  label: "Pinterest"
}, {
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}];
export default function Footer() {
  return <section data-section-id="231915" id="footer" className="dark bg-background text-foreground" style={{
    backgroundColor: "#1A1716"
  }}>
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {}
          <div className="flex flex-col gap-5">
            <Link to="/" className="flex items-center gap-2 w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645038/img/voltpro_footer_logo.png" alt="CRUST" className="h-7" />
            </Link>
            <p className="text-sm leading-relaxed font-default" style={{
            color: "var(--muted-foreground)"
          }}>
              Crafting artisan breads and delicate pastries using time-honored techniques and premium local ingredients. A boutique bakery experience delivered to your door.
            </p>
            {}
            <div className="flex items-center gap-3 mt-2">
              {socialLinks.map((social, i) => <Link data-index={i} key={social.label} to={social.href} aria-label={social.label} className="group p-2 rounded-full border transition-all duration-300 hover:bg-primary/10" style={{
              borderColor: "var(--border)",
              color: "var(--muted-foreground)"
            }}>
                  <social.icon className="size-4 transition-colors duration-200 group-hover:text-primary" style={{
                color: "inherit"
              }} />
                </Link>)}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-default text-sm font-semibold tracking-widest uppercase" style={{
            color: "var(--primary)"
          }}>
              Navigation
            </h3>
            <ul className="flex flex-col gap-3">
              {quickLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.href} className="text-sm transition-colors duration-200 hover:text-primary font-default" style={{
                color: "var(--muted-foreground)"
              }}>
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-default text-sm font-semibold tracking-widest uppercase" style={{
            color: "var(--primary)"
          }}>
              Our Offerings
            </h3>
            <ul className="flex flex-col gap-3">
              {services.map((service, i) => <li data-index={i} key={service}>
                  <span className="text-sm flex items-start gap-2 font-default" style={{
                color: "var(--muted-foreground)"
              }}>
                    <Zap className="size-3.5 mt-0.5 shrink-0" style={{
                  color: "var(--primary)"
                }} />
                    {service}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-default text-sm font-semibold tracking-widest uppercase" style={{
            color: "var(--primary)"
          }}>
              Visit Us
            </h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <MapPin className="size-4 mt-0.5 shrink-0" style={{
                color: "var(--primary)"
              }} />
                <span className="text-sm leading-relaxed font-default" style={{
                color: "var(--muted-foreground)"
              }}>
                  124 Baker Street, Artisan Quarter, London
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-4 shrink-0" style={{
                color: "var(--primary)"
              }} />
                <Link to="tel:+442071234567" className="text-sm transition-colors duration-200 hover:text-primary font-default" style={{
                color: "var(--muted-foreground)"
              }}>
                  +44 20 7123 4567
                </Link>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-4 shrink-0" style={{
                color: "var(--primary)"
              }} />
                <Link to="mailto:hello@crustbakery.com" className="text-sm transition-colors duration-200 hover:text-primary font-default" style={{
                color: "var(--muted-foreground)"
              }}>
                  hello@crustbakery.com
                </Link>
              </li>
              <li className="mt-1">
                <span className="inline-block text-xs font-mono px-3 py-1.5 rounded-md border" style={{
                color: "var(--primary)",
                borderColor: "var(--primary)",
                backgroundColor: "hsla(22, 40%, 55%, 0.1)",
                fontFamily: "var(--font-mono)"
              }}>
                  Tue-Sun: 07:00 - 16:00
                </span>
              </li>
            </ul>
          </div>
        </div>

        {}
        <Separator className="mb-6" style={{
        backgroundColor: "var(--border)"
      }} />

        {}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-default" style={{
          color: "var(--muted-foreground)"
        }}>
            &copy; {new Date().getFullYear()} CRUST Artisan Bakery. All rights reserved.
          </p>
          <p className="text-xs font-default px-4 py-1 rounded-full border transition-colors hover:bg-primary hover:text-primary-foreground cursor-pointer" style={{
          color: "var(--primary)",
          borderColor: "var(--primary)"
        }} onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })}>
            Back to Top
          </p>
        </div>
      </div>
    </section>;
}